import { FileReceivedIcon } from '../../../../icons';

interface IFileItemProps {
  file: File;
  onRemoveFile: (file: File) => void;
}

/**
 * -----------------------------------------------------------------------------
 * It renders the file item with a file name and a remove button
 */
export function FileItem({ file, onRemoveFile }: Readonly<IFileItemProps>) {
  const handleOnClick = () => {
    onRemoveFile(file);
  };

  return (
    <div className="flex items-center justify-center gap-2">
      <div className="h-5 w-5">
        <FileReceivedIcon />
      </div>
      <div>{file.name}</div>
      <button
        className="cursor-pointer text-2xl text-gray-500"
        onClick={handleOnClick}
        type="button"
      >
        &times;
      </button>
    </div>
  );
}
